import { CommonModule, registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, enableProdMode, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { ActivatedRouteSnapshot, provideRouter, RouterStateSnapshot } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthConfigModule } from "./auth/auth-config.module";
import { HttpDateInterceptor } from "./core/interceptors/http-date.interceptor";
import { HttpErrorInterceptor } from "./core/interceptors/http-error.interceptor";
import { HeaderInterceptor } from "./core/interceptors/http-header.interceptor";
import { SharedComponentsModule } from "./shared/shared-components.module";
import { structuredMerge } from "../functions/structuredMerge";
import { AppSettings, APP_SETTINGS } from "./app.settings";
import { env } from "../environments/env";
import { fetch_retry } from "src/functions/fetch_retry";
import { routes } from "./app.routing";

import localeSv from "@angular/common/locales/sv";
registerLocaleData(localeSv, "sv");


const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(AuthConfigModule, BrowserModule, CommonModule, NgbModule, FormsModule, ReactiveFormsModule, SharedComponentsModule),
        { provide: LOCALE_ID, useValue: "sv" },
        {
            provide: "externalUrlRedirectResolver",
            useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
                window.location.href = (route.data as any).externalUrl;
            }
        },
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpDateInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        provideZoneChangeDetection(),
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(routes)
    ]
};


export async function getApplicationConfig(): Promise<ApplicationConfig | null> {
    const baseHref = (document.getElementsByTagName("base")[0] || {}).href;

    try {
        const backendSettings = await fetch_retry("api/settings", 10);

        if (env.production) {
            enableProdMode();
            window.console.debug = function () { /* disable any console.debug debugging statements in production mode */ };
        }

        // Merge environment with settings
        const settings = new AppSettings();
        structuredMerge(settings, env, backendSettings);
        // Get href from base element
        if (settings.baseHref == "")
            settings.baseHref = baseHref;

        if (!env.production)
            console.log(settings);

        appConfig.providers.push({ provide: APP_SETTINGS, useValue: settings });

        return appConfig;
    }
    catch (error) {
        alert("Ingen kontakt med servern!");
        return null;
    }
}

